import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { LocationServiceFetch } from "../../slices/locationSlice"
import { addHours } from "../../common/DateTime"
const LocationTrack = props => {
  const { children } = props
  const dispatch = useDispatch()
  const location = useSelector(state => state.location)
  useEffect(() => {
    if (location?.coords?.lat === undefined) {
      dispatch(LocationServiceFetch({}))
    } else if (
      //every hour keep checking the user location
      location?.updatedOn &&
      new Date() > addHours({hours: 1,date:new Date(location.updatedOn)})
    ) {
      dispatch(LocationServiceFetch({}))
    }
  }, [location])
  return children
}
export default LocationTrack
